import {CSSProperties, FC} from 'react';


export interface IIconPin2Props {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPin2: FC<IIconPin2Props> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 17"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M7 .627A6.195 6.195 0 0 0 .813 6.814a6.131 6.131 0 0 0 1.246 3.713s.169.222.196.254L7 16.377l4.747-5.599c.025-.03.194-.251.194-.251v-.002a6.131 6.131 0 0 0 1.246-3.71A6.195 6.195 0 0 0 7 .626Zm0 8.437a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z" />
        </svg>
    );
};
